import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { GENDER } from '../../../shared/constansts/app.const';
import { SelectOption } from '../../../shared/models/select-option.model';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { Organization } from '../../../shared/models/Organization.model';
import { BaseFormComponent } from '../../../shared/class/base-form.class';
import { User } from '../../../shared/models/user.model';
import { ApiResponse } from '../../../shared/interfaces/api-response.interface';
import { removeFalsyValues } from '../../../shared/utils/functions/util-functions';
import { Role } from '../../../shared/models/role.model';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrl: './edit-user.component.scss'
})
export class EditUserComponent extends BaseFormComponent implements OnInit {
  @ViewChild('formRef')
  formRef!: FormGroupDirective;
  @Input() groupData: any;
  orgId!: number;
  userDetails: User | undefined;
  organizationOptions: any = [];

  get formControl() {
    return this.editUserForm.controls;
  }

  genderOptions = GENDER;
  date: Date | undefined;
  roleOptions: any = []

  editUserForm = this.fb.group({
    firstName: new FormControl('', [
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(40),
      Validators.pattern('^[a-zA-Z0-9-+\\s/\\_]*$') // Fixed the regex pattern
    ]),
    lastName: new FormControl('', [
      Validators.required,
      Validators.minLength(1),
      Validators.maxLength(40),
      Validators.pattern('^[a-zA-Z0-9-+\\s/\\_]*$') // Fixed the regex pattern
    ]),
    email: new FormControl('', [Validators.required, Validators.email]),
    mobile: new FormControl('', [
      Validators.pattern(/^\d{6,10}$/),
      Validators.minLength(6),
      Validators.maxLength(10),
      Validators.required
    ]),
    gender: new FormControl('', [Validators.required]),
    dob: new FormControl(''),
    organization: new FormControl<Partial<Organization> | undefined>(undefined, Validators.required),
    roles: new FormControl<{id:number}[]>([], [Validators.required]),
    gstInNumber: new FormControl(''),
    orgName: new FormControl('')
  });
  constructor(protected override fb: FormBuilder) {
    super();
  }

  ngOnInit(): void {
    this.id = this.route.snapshot.params['id'];
    if(this.id){
      this.getUserDetails(this.id);
      this.getOrganization()
      this.getUserRole()
    }
  }


  async getUserRole() {

    let response: ApiResponse<[Role[], number]> = await this.httpService.httpRequest<[Role[], number]>(
      "role",
      "find-all-and-count-by-admin",
    );
    if (response.status && response.data) {
      this.roleOptions = response.data[0].map(role=> ({name: role.name, value: {id: role.id}}));
    }
  }



  async getOrganization() {
    let response: ApiResponse<[Organization[], number]> =
      await this.httpService.httpRequest<[Organization[], number]>(
        "organization",
        "find-all-and-count-by-admin"
      )
    if (response.status && response.data) {
      this.organizationOptions = response.data[0];
    }
  }

  async getUserDetails(userId: number) {
    if (userId) {

      let response: ApiResponse<User> = await this.httpService.httpRequest<User>(
        "user",
        "get-by-admin",
        {
          id: userId,
          relations: 'organization,roles'
        }
      );
      if (response.status) {
        this.userDetails = response.data!;
        this.editUserForm.patchValue({
          firstName: this.userDetails.firstName,
          lastName: this.userDetails.lastName,
          email: this.userDetails.email,
          mobile: this.userDetails.mobile,
          gender: this.userDetails.gender,
          organization: this.userDetails?.organization,
          roles: this.userDetails.roles.map(role => ({id: role.id}))
        });

        return;
      }
    }
  }

  async updateUserDetails() {
    this.isSubmitted.set(true);
    if (this.editUserForm) {
      let payload = removeFalsyValues(this.editUserForm.value);
      payload = {
        ...payload,
        id: this.id,
        organization: {
          id: payload.organization
        },
        roles: payload.roles,
      }
      let response: ApiResponse<any> = await this.httpService.httpRequest<any>(
        "user",
        "update-by-admin",
        payload
      );
      if (response.status && response.data) {
        this.notificationService.showSuccess(response.message);
        this.editUserForm.reset();
        this.isSubmitted.set(false);
        this.router.navigateByUrl("/settings/users");
      } else {
        this.notificationService.showError(response.message);
      }
    }
  }
}
